import { Theme } from '@mui/material';
import styled from '@emotion/styled';
import { Link } from "react-router-dom";

import { Box } from '@mui/material';

type ParamsStyle = {
    theme?: Theme;
}

type ParamsStyleMobile = {
    theme?: Theme;
    backgroundimg: string;
}

export const LinkButton = styled(Link)(
    ({ theme }: ParamsStyle) => `
        width: 100%;
        display: flex;
        height: 2.5rem;
        border-radius: 5px;
        text-aling: center;
        align-items: center;
        justify-content: center;
        border: 2px solid ${theme?.palette.primary.main};

        font-size: .93rem;
        font-weight: 700;
        margin-top: 1rem;
        color: ${theme?.palette.primary.main};

        svg {
            margin-right: 8px;
        }
`);

export const ContentNewsMobile = styled.div(
    ({ theme }: ParamsStyle) => `
        width: 100%;
        display: block;
        padding: 2rem 0 0;

        .MuiButtonBase-root.MuiIconButton-root.MuiIconButton-sizeMedium {
            margin-top: -65px;
            display: none;

            svg {
                z-index: 1;
            }
        }

        @media(min-width: ${theme?.breakpoints.values.md}px) {
            display: none;
        }
`);

export const CardBanner = styled.div(
    ({ theme, backgroundimg }: ParamsStyleMobile) => `
        width: 100%;
        height: 10.375rem;
        border-radius: 20px;
        background: url('${backgroundimg}');
        background-size: cover;
        background-repeat: no-repeat;

        display: flex;
        align-items: center;
        justify-content: center;
`);

export const BoxAnimationBanner = styled(Box)(
    () => `
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: .8rem
`);
